import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Vine - the crappiest app I can't help but love",
  "description": "",
  "published": "2013-01-31T00:00:00.000Z",
  "redirect_from": ["/blog/vine-the-crappiest-app-i-cant-help-but-love/swizec/5926"],
  "categories": "Instagram, Stop motion, Twitter, Uncategorized, Vine",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Earlier this week, or maybe it was late last week, Twitter released a smashing new service called `}<a parentName="p" {...{
        "href": "http://vineapp.com/"
      }}>{`Vine`}</a>{`. The simplest possible value proposition - `}<a parentName="p" {...{
        "href": "http://instagr.am/",
        "title": "Instagram"
      }}>{`Instagram`}</a>{` for video.`}</p>
    <p>{`Or possibly "`}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Graphics_Interchange_Format",
        "title": "Graphics Interchange Format"
      }}>{`GIFs`}</a>{` for the rest of us".`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "und",
        "dir": "ltr"
      }}>{`Mmmmmmm `}<a parentName="p" {...{
          "href": "http://t.co/hLr2SdJ6"
        }}>{`http://t.co/hLr2SdJ6`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/296719923902828544"
      }}>{`January 30, 2013`}</a></blockquote>
    <p>{`I can't quite decide which it is. All I know is that as soon as I saw Vine I knew, I just `}<em parentName="p">{`knew`}</em>{`, there was nothing I have ever wanted to do more in my life than make short 6 second looping videos of the boring crap I do day to day.`}</p>
    <p>{`Sure, a picture says a thousand words, a picture with a filter might even say 1200 words. But a 6 second video? Wow, that's 144 pictures! 144,000 words! Think of all the things you can say! The tiny stories you can tell! The ...`}</p>
    <p>{`Reality is far from fantasy, though. At least for me.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`I needed 5 attempts to Vine this. `}<a parentName="p" {...{
          "href": "http://t.co/EqLeO9hN"
        }}>{`http://t.co/EqLeO9hN`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/296283862428942336"
      }}>{`January 29, 2013`}</a></blockquote>
    <p>{`Every time I try to make a new Vine I realize that I am a `}<strong parentName="p"><em parentName="strong">{`crappy`}</em></strong>{`_`}{`_`}{` video creator. While Instagram fills me with love for the beautiful things I can make at the tap of a cold glass screen, Vine fills me with dread. My total failure at even taking a stable shot. At telling anything remotely compelling. It's all right there. Plain for all to see.`}</p>
    <p>{`Whenever I'm doing something, that means using my `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Handedness",
        "title": "Handedness"
      }}>{`dominant hand`}</a>{`. I want to make videos of doing something `}{`[`}{`interesting]. But that means holding the phone with my left hand. My left hand is crap at everything.`}</p>
    <p>{`Then we come to conveying a story, keeping the shots interesting, playing with the whole idea of taking bursts of video to create something akin to a `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Stop_motion",
        "title": "Stop motion"
      }}>{`stop-motion animation`}</a>{` and ... it's just a little too much. My engineering brain can't handle the boundless possibilities.`}</p>
    <p>{`Then there's the crashing. Vine ... it just doesn't work very well.`}</p>
    <p>{`First of all, it will simply crash whenever you aren't connected to the internet. Found something cool in a parking garage? Forget about it. You might be able to make the video, but then the app will crash and lose it.`}</p>
    <p>{`Even when you are connected to the internet, only one in five videos will actually succeed. Sometimes the app fizzes out during filming. Sometimes you make the whole video and instead of a preview you get a `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Black_Screen_of_Death",
        "title": "Black Screen of Death"
      }}>{`black screen`}</a>{`. But Vine doesn't let you lose hope. Oh no, it promises that it's simply the upload failing.`}</p>
    <p>{`It's not. The video is gone. All those `}<em parentName="p">{`seconds`}</em>{` of hard work. Just gone.`}</p>
    <p>{`Whenever even the tiniest thing goes wrong, your video just `}{`*`}{`poof`}{`*`}{` vanishes. Just another bleep on your infinite history of failure.`}</p>
    <p>{`But my god I am falling in love with this app. Sure it takes at least five attempts to create anything, but that's just part of the charm you know?`}</p>
    <p>{`Perhaps someday, maybe, Vine will help us all achieve greatness.`}</p>
    <p>{`<`}{`tweet gone missing>`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://rjmarmol.com/2013/01/30/vineit-lets-you-easily-share-vine-videos-on-tumblr/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/141722974_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://rjmarmol.com/2013/01/30/vineit-lets-you-easily-share-vine-videos-on-tumblr/"
        }}>{`Vineit Lets You Easily Share Vine Videos on Tumblr`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.livescience.com/26745-vine-app-melies-magic.html"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/141910820_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.livescience.com/26745-vine-app-melies-magic.html"
        }}>{`Twitter's Vine Revives 1890s Magic Movies`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://suburbanmen.com/vine-app-is-crap/18171/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/141571872_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://suburbanmen.com/vine-app-is-crap/18171/"
        }}>{`Vine App is Crap`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.petapixel.com/2013/01/28/that-explains-it-the-difference-between-instagram-and-vine/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/141314871_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.petapixel.com/2013/01/28/that-explains-it-the-difference-between-instagram-and-vine/"
        }}>{`That Explains It: The Difference Between Instagram and Vine`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.blogher.com/second-look-vine-make-scene"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/141812395_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "https://www.blogher.com/second-look-vine-make-scene"
        }}>{`A Second Look at Vine - Make a Scene`}</a></li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=97299318-2e70-4d58-a0c3-fe55610de74f",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      